import { urlBase } from "../config";
import axiosInstance from "../../services/config/axiosinstance";

const baseUrl = `${urlBase}/portal-events/config-contracts`;

async function create(contract, jwt) {
  const config = {
    method: "post",
    url: `${baseUrl}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: contract,
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

async function getByContractId(contractId) {
  const config = {
    method: "get",
    url: `${baseUrl}/${contractId}/contract`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

async function edit(data, id) {
  const config = {
    method: "put",
    url: `${baseUrl}/${id}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export { create, edit, getByContractId };
